'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const CellStyled = styled__default.default.td `
  padding: ${({ theme }) => `${theme.space.table.xl} ${theme.space.table.l} ${theme.space.table.xl} ${theme.space.table.xxs}`};
  font-size: ${({ theme }) => theme.typography.fontSize.s};
  font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
  line-height: ${({ theme }) => theme.typography.lineHeight.s};
  letter-spacing: ${({ theme }) => theme.typography.letterSpacing.m};
  color: ${({ theme }) => theme.colors.body.text};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  &:first-child {
    padding-left: ${({ theme }) => theme.space.table.s};
  }

  ${({ $removePadding }) => $removePadding
    ? `
    padding-top: 0;
    padding-bottom: 0;
  `
    : ''}

  ${({ $alignMiddle }) => $alignMiddle
    ? `
    & * {
      vertical-align: middle;
    }
  `
    : ''}

  ${({ $centerContent }) => $centerContent
    ? `
      > span {
        display: flex;
        width: 100%;
        justify-content: center;
      }
      `
    : ''}
`;

exports.CellStyled = CellStyled;
//# sourceMappingURL=cell.styles.js.map
